module.exports = __webpack_public_path__ + "static/media/timestamp.6ef0dac9.svg";